import { render, staticRenderFns } from "./sbo.vue?vue&type=template&id=1c08a36c&scoped=true&"
import script from "./sbo.vue?vue&type=script&lang=js&"
export * from "./sbo.vue?vue&type=script&lang=js&"
import style0 from "./sbo.vue?vue&type=style&index=0&id=1c08a36c&prod&scoped=true&lang=css&"
import style1 from "./sbo.vue?vue&type=style&index=1&id=1c08a36c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08a36c",
  null
  
)

export default component.exports